import { PDFDocument, StandardFonts, rgb } from 'pdf-lib'
import SOATemplate from './template-feb-13-26.pdf'
import computeXBasedOnAlignment from '../computeXBasedOnAlignment';
import { toWords } from 'number-to-words';
import netBillingToWords from '../netBillingToWords';
//import { TextAlignment, rgb } from 'pdf-lib';
//import { convertFieldResponseIntoMuiTextFieldProps } from '@mui/x-date-pickers/internals';
import urlToBlob from 'utils/urlToBlob';
import generateBillingDetails from '../generateBillingDetails';
import generateCutoff from 'utils/generateCutoff'

let templateMap = {
    billed_to: {
        x: 110,
        y: 616,
        size: 10,
        fontWeight: 'bold'
    },
    admin_cost: {
        x: 452,
        y: 561,
        size: 10,
        alignment: 'right',
        width: 80,
    },
    sum_billing: {
        x: 452,
        y: 548,
        size: 10,
        alignment: 'right',
        fontWeight: 'bold',
        width: 80,
    },

    cutoff: {
        x: 112,
        y: 525,
        size: 10,
        fontWeight: 'bold',
        width: 200,
        alignment: 'center'
    },


    total_billing: {
        x: 452,
        y: 509,
        size: 10,
        alignment: 'right',
        width: 80,
        fontWeight: 'bold'
    },

    salary_deduction: {
        x: 452,
        y: 497,
        size: 10,
        alignment: 'right',
        width: 80,
    },

    meal_allowance: {
        x: 452,
        y: 486,
        size: 10,
        alignment: 'right',
        width: 80,

    },
    other_deductions: {
        x: 452,
        y: 474,
        size: 10,
        alignment: 'right',
        width: 80,
    },

    net_billing_computed:{
        x: 452,
        y: 474,
        size: 10,
        alignment: 'right',
        width: 105,
        fontWeight: 'bold'
    },

    date_settlement: {
        x: 329,
        y: 310,
        size: 10,
        width: 170, 
        alignment: 'center'
    },

    gross_billing: {
        x: 452,
        y: 574,
        size: 10,
        width: 80,
        alignment: 'right',
        fontWeight: 'bold'
    },
    amount_in_words: {
        x: 100,
        y: 465,
        size: 10,
        width: 200,
        maxWidth: 200,
        fontWeight: 'bold',
        wordBreaks: [" "],
        lineHeight: 10,
    },


    store: {

        x: 110,
        y: 600,
        size: 10,
        fontWeight: 'bold'
    },
    vat: {
        x: 452,
        y: 538,
        size: 10,
        alignment: 'right',
        width: 80,
    },
    withholding_tax: {
        x: 452,
        y: 524,
        size: 10,
        alignment: 'right',
        width: 80,
    },
    denomination: {
        x: 342,
        y: 440,
        size: 15,
        width: 50
    },
    net_billing: {
        x: 382,
        y: 440,
        size: 15,
        alignment: 'right',
        width: 145
    },

    net_billing_computed: {
        x: 452,
        y: 460,
        size: 10,
        alignment: 'right',
        width: 80,
    },

     
    date: {
        x: 433,
        y: 600,
        size: 10,
        width: 100,
        fontWeight: 'bold',
        alignment: 'right',
        backgroundColor: rgb(0.71, 0.78, 0.90)
    },


    soa_number: {
        x: 455,
        y: 615,
        size: 10,
        fontWeight: 'bold',
        width: 78,
        alignment: 'right',
        backgroundColor: rgb(0.71, 0.78, 0.90)
    },

    payroll_head: {
        x: 63,
        y: 223,
        size: 10,
        fontWeight: 'bold'
    },

    payroll_manager: {
        x: 341,
        y: 223,
        size: 10,
        fontWeight: 'bold'
    },

    director_finance_dept: {
        x: 63,
        y: 148,
        size: 10,
        fontWeight: 'bold'
    },

    president: {
        x: 341,
        y: 148,
        size: 10,
        fontWeight: 'bold'
    },

}


export default async function generateSOA7star(generatedBillingDetails = {}) {
 
    let amountInWords = await netBillingToWords(generatedBillingDetails.net_billing)
    let newBillingDetails = {
        ...generatedBillingDetails,
        amount_in_words: amountInWords,
        denomination: "PHP",
        cutoff: generateCutoff(generatedBillingDetails.payroll_from, generatedBillingDetails.payroll_to),
    }


    try {
        let downloadedPDF = await urlToBlob(SOATemplate)
        let downloadedPDFBlob = await downloadedPDF.arrayBuffer()
        const templateDoc = await PDFDocument.load(downloadedPDFBlob)
        const boldFont = await templateDoc.embedFont(StandardFonts.HelveticaBold)
        const normalFont = await templateDoc.embedFont(StandardFonts.Helvetica)
        let pages = templateDoc.getPages()
        let firstPage = pages[0]
        let form = templateDoc.getForm()



        Object.keys(newBillingDetails).forEach((key) => {
            let mappingDetails = templateMap[key]

            if (mappingDetails) {
                let text = String(newBillingDetails[key])

                if (typeof newBillingDetails[key] === 'number') {
                    text = Number(newBillingDetails[key]).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                }

                //draw background color first
                if (mappingDetails?.backgroundColor) {
                    firstPage.drawRectangle({
                        ...mappingDetails,
                        height: mappingDetails.size,
                        color: mappingDetails.backgroundColor
                    })
                }

                let font = mappingDetails.fontWeight === 'bold' ? boldFont : normalFont
                let textWidth = mappingDetails.fontWeight === 'bold' ? boldFont.widthOfTextAtSize(text, mappingDetails.size) : normalFont.widthOfTextAtSize(text, mappingDetails.size)
                let x = computeXBasedOnAlignment(mappingDetails.alignment, mappingDetails.x, textWidth, mappingDetails.width)

                console.log(`Drawing text "${text}" at x: ${x}, y: ${mappingDetails.y}, fontSize: ${mappingDetails.size}, fontWeight: ${mappingDetails.fontWeight}, width: ${mappingDetails.width}`)

                if (mappingDetails?.backgroundColor) {
                    firstPage.drawRectangle({
                        //...mappingDetails,
                        x: mappingDetails.x,
                        y: mappingDetails.y -2,
                        width: mappingDetails.width,
                        height: mappingDetails.size,
                        color: mappingDetails.backgroundColor
                    })
                }

                if (mappingDetails?.fontColor === 'white')
                    firstPage.setFontColor(rgb(1, 1, 1))
                else
                    firstPage.setFontColor(rgb(0, 0, 0))


                firstPage.drawText(text, {
                    ...mappingDetails,
                    x: x,
                    font: font
                })

                //for debugging purposes



               /*

                if (mappingDetails.alignment === 'right' || mappingDetails.alignment === 'center') {
                    console.log('right alignment', key)



                    firstPage.drawRectangle({
                        ...mappingDetails,
                        height: 10,
                        width: textWidth,
                        borderColor: rgb(0, 1, 0),
                        borderWidth: 2
                    })

                    firstPage.drawRectangle({
                        ...mappingDetails,
                        height: 10,
                        borderColor: rgb(1, 0, 0),
                    })
                }
                // 

  */


            }
          
        })






        const pdfBytes = await templateDoc.save()

        let blob = new Blob([pdfBytes], {
            type: 'application/pdf'
        });

        let blobURL = `${URL.createObjectURL(blob)}`;

        window.open(blobURL)
        fetch(blobURL)

    } catch (err) {
        console.log(err)
    }
}
